import { render } from "./yacht-categories.vue?vue&type=template&id=0a378f3a"
import script from "./yacht-categories.vue?vue&type=script&lang=js"
export * from "./yacht-categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__